import React from 'react';
import { AppWrap, MotionWrap } from '../../wrapper';
import { motion } from 'framer-motion';
import { MdEmail } from "react-icons/md";
import { SiBuymeacoffee } from "react-icons/si";
import { FaCalendarCheck } from "react-icons/fa";
import './Footer.scss';
const Footer = () => {

  return (
    <>
      <h2 style={{ color: "var(--primary-color)" }}>Get in touch</h2>

      <div className="app__footer-cards">
        <motion.div 
          className="app__footer-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: 'spring', stiffness: 400, damping: 10 }}
        >
          <a href="mailto:abdeallahhallou33@gmail.com">
            <MdEmail size={35} color="#6366f1" style={{ margin: '0 0.7rem' }} />
          </a>
          <a href="mailto:abdeallahhallou33@gmail.com" className="p-text">Contact</a>
        </motion.div>
        
        <motion.div 
          className="app__footer-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: 'spring', stiffness: 400, damping: 10 }}
        >
          <a target="_blank" rel="noreferrer" href="https://www.buymeacoffee.com/abdellahhallou">
            <SiBuymeacoffee size={35} color="#FFDD00" style={{ margin: '0 0.7rem' }} />
          </a>
          <a className="p-text" target='_blank' rel="noreferrer" href="https://www.buymeacoffee.com/abdellahhallou">Lets share a coffee</a>
        </motion.div>

        <motion.div 
          className="app__footer-card"
          whileHover={{ scale: 1.05 }}
          transition={{ type: 'spring', stiffness: 400, damping: 10 }}
        >
          <a target="_blank" rel="noreferrer" href="https://calendly.com/abdeallahhallou/30min">
            <FaCalendarCheck size={35} color="#006bff" style={{ margin: '0 0.7rem' }} />
          </a>
          <a className="p-text" target="_blank" rel="noreferrer" href="https://calendly.com/abdeallahhallou/30min">Lets meet (30 min)</a>
        </motion.div>
      </div>

      <form 
        action="https://formspree.io/f/mykvyqey" 
        method="POST" 
        className="app__footer-form app__flex"
      >
        <div className="app__footer-field">
          <label htmlFor="contact-name">Name</label>
          <input id="contact-name" className="p-text" type="text" placeholder="Your Name" name="name" required />
        </div>
        <div className="app__footer-field">
          <label htmlFor="contact-email">Email *</label>
          <input id="contact-email" className="p-text" type="email" placeholder="your.email@example.com" name="_replyto" required />
        </div>
        <div className="app__footer-field">
          <label htmlFor="contact-message">Message</label>
          <textarea
            id="contact-message"
            className="p-text"
            placeholder="Your Message"
            name="message"
            required
          />
        </div>
        <button type="submit" className="experience-btn" style={{ marginTop: '2rem' }}>Send Message</button>
      </form>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
